import { useEffect, useState } from 'react';

import Router from 'next/router';
import PropTypes from 'prop-types';

import { warrantyActivationSuccess } from '../../helpers/warranty-activation-segment';
import useI18n from '../../hooks/use-i18n';
import { countryMap } from '../../language.config';

import '../../styles/revamp/warranty-activated-modal-embed.scss';

function WarrantyActivatedModalEmbed(props) {
  const { warrantyDetails } = props;

  const i18n = useI18n();
  const warrantyLandingPage = i18n.t('warranty_activation').landing_page;
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';

  const [dates, setDates] = useState({
    activationDate: '',
    expiryDate: ''
  });

  const handleDateFormat = (date) => {
    const day = new Date(date);
    return (`${day.getDate()}/${(day.getMonth() < 10 ? '0' : '') + (day.getMonth() + 1)}/${day.getFullYear()}`);
  };

  const exitModal = () => {
    Router.push(`/${i18n.activeLocale}/warranty-activation/embed/warranty-device-details?id=${warrantyDetails?.id}`);
  };

  const closeModal = () => {
    setTimeout(exitModal, 3000);
  };

  useEffect(() => {
    closeModal();
  }, []);

  useEffect(() => {
    if (warrantyDetails) {
      warrantyActivationSuccess(countryMap[country], warrantyDetails?.product?.name);
      setDates({ activationDate: handleDateFormat(warrantyDetails?.warrantyActivationDate),
        expiryDate: handleDateFormat(warrantyDetails?.warrantyExpirationDate) });
    }
  }, [warrantyDetails]);

  return (
    <div className="warranty-activated-modal-wrapper" role="presentation" onClick={exitModal}>
      <div className="modal-inner" role="presentation" onClick={(e) => e.stopPropagation()}>
        <div className="modal-gradient">
          <div className="warranty-activated-section">
            <img src="/img/warranty/warranty_success.gif" alt="success_icon" data-gumlet="false" />
            <h2
              data-lokalise=""
              data-key="warranty_activation::landing_page::warranty_activated"
            >
              {warrantyLandingPage.warranty_activated}

            </h2>
            <p
              data-lokalise=""
              data-key="warranty_activation::landing_page::device_warranty_will_expire_on"
            >
              {warrantyLandingPage.device_warranty_will_expire_on}
              {' '}
              <span>{dates.expiryDate}</span>
              .
            </p>
            <p
              data-lokalise=""
              data-key="warranty_activation::landing_page::confirmation_email_msg"
            >
              {warrantyLandingPage.confirmation_email_msg}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WarrantyActivatedModalEmbed;

WarrantyActivatedModalEmbed.propTypes = {
  warrantyDetails: PropTypes.shape()
};

WarrantyActivatedModalEmbed.defaultProps = {
  warrantyDetails: {}
};
